module.exports = __webpack_public_path__ + "static/media/duct-design.496e2149.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/duct-design.png
// module id = 59
// module chunks = 0